export default __webpack_public_path__ + "static/media/Logo_Balearic.01672cd6.svg";